<template>
  <vue-slider v-model="value" @change="$emit('input', value)" />
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/material.css'

export default {
  name: 'Range',
  components: {
    VueSlider
  },
  data: () => ({
      value: [0, 100]
  })
}
</script>

<style lang="scss">
@import "../../../scss/global/includes";

.vue-slider-process, .vue-slider-dot-handle, .vue-slider-dot-tooltip-inner {
	background-color: $primary;
}

.vue-slider-rail, .vue-slider-dot-handle::after {
	background-color: $primary-faded;
}

</style>